import { supabase } from '../lib/supabaseClient';
import type { Reservation } from '../mocks/reservations';

function toReservation(row: Record<string, unknown>): Reservation {
  return {
    id: row.id as string,
    tourId: row.tour_id as string,
    tourName: row.tour_name as string,
    firstName: row.first_name as string,
    lastName: row.last_name as string,
    email: row.email as string,
    phone: row.phone as string,
    departureDate: (row.departure_date as string) || '',
    adults: row.adults as number,
    children: row.children as number,
    specialRequests: (row.special_requests as string) || '',
    status: row.status as Reservation['status'],
    createdAt: row.created_at as string,
    totalPrice: row.total_price as number,
    currency: row.currency as 'TL' | '€',
  };
}

export async function getReservations(): Promise<Reservation[]> {
  const { data, error } = await supabase
    .from('reservations')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Rezervasyonlar alınamadı:', error.message);
    return [];
  }
  return (data || []).map(toReservation);
}

export async function saveReservation(reservation: Reservation): Promise<void> {
  const { error } = await supabase.from('reservations').insert([
    {
      id: reservation.id,
      tour_id: reservation.tourId,
      tour_name: reservation.tourName,
      first_name: reservation.firstName,
      last_name: reservation.lastName,
      email: reservation.email,
      phone: reservation.phone,
      departure_date: reservation.departureDate || null,
      adults: reservation.adults,
      children: reservation.children,
      special_requests: reservation.specialRequests,
      status: reservation.status,
      created_at: reservation.createdAt,
      total_price: reservation.totalPrice,
      currency: reservation.currency,
    },
  ]);

  if (error) {
    console.error('Rezervasyon kaydedilemedi:', error.message);
    throw error;
  }
}

export async function updateReservationStatus(
  id: string,
  status: Reservation['status'],
): Promise<void> {
  const { error } = await supabase
    .from('reservations')
    .update({ status })
    .eq('id', id);

  if (error) {
    console.error('Durum güncellenemedi:', error.message);
    throw error;
  }
}
